import icon_back from "../../../../SubUsers/images/back-button.png";
import icon_small_screen from "../../images/full-screen_.png";
import icon_full_screen from "../../images/full-screen.png";
import InfoField from "../InfoField/InfoField";
import Slider from "react-slick";
import { useEffect, useState } from "react";
import { get_day_epg } from "../../../../../server/requests";
import { formatDate, formatTime } from "../../../../Util/format_date";
import ProgramGuide from "../ProgtamGuide/ProgramGuide";
import Categories from "../Categories/Categories";
import { useRouter } from "../../../../../hooks/router";
import PremiumField from "../../../../pages_child/PremiumField/PremiumField";
import icon_lock from "../../images/lock.png";
import icon_rec from "../../images/original.png";
import icon_premium from "../../images/premium.png";

export default function LivePlayer({
    activeMedia,
    playPause,
    btn_play_pause,
    channels,
    fullScreen,
    btn_full_screen,
    show_time_shift,
    callBackArchiveEpg,
    btn_next_channel,
    btn_previous_channel,
    channelFavourite,
    btn_add_remove_favourites,
    showErrorMessage,
    isGuest
}) {

    const router = useRouter()

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 11,
        slidesToScroll: 11,
        initialSlide: 0,
    };

    const [activeList, setActiveList] = useState([
        { id: 0, name: 'Favourites', active: false },
        { id: 1, name: 'All Channels', active: true },
    ])
    const [info, setInfo] = useState(false)
    const [activeListIndex, setActiveListIndex] = useState(1)
    const [epgList, setEpgList] = useState([])
    const [epg, setEpg] = useState({ Now: null, next: null })
    const [showFieldLive, setShowFieldLive] = useState('')

    useEffect(() => {

        if (activeMedia) {
            get_day_epg_list(0)
        }

    }, [activeMedia])

    useEffect(() => {
        if (!channels[0].array.length) {
            if (channels && channels[1]?.array.length) {
                console.log('kjasndlksandlkk')
                btnSortChannel(activeList[1])
            }
        }
    }, [channelFavourite])

    const get_day_epg_list = (date) => {
        const body = {
            date: date,
            id: activeMedia.id_epg
        }
        get_day_epg(body, data => {
            if (data.length) {
                setEpgList([...data])
                sort_epg_in_stream(data)
            }
        })
    }

    function sort_epg_in_stream(data) {

        var now = new Date().getTime() / 1000;


        for (var i = 0; i < data.length; i++) {

            if (data[i].start_ut < now && now < data[i].stop_ut) {

                setEpg({
                    Now: data[i] ? data[i] : null,
                    next: data[i + 1] ? data[i + 1] : null
                })

                break

            }

        }


    }

    const btnSortChannel = (e) => {
        let newArr = activeList
        let x = newArr.find(k => k.active === true)
        x.active = false
        e.active = true
        setActiveList([...newArr])
        setActiveListIndex(e.id)
    }

    const btn_show_info = () => {
        setInfo(!info)
    }

    const btn_fields_live = (x) => {
        let type
        if (x) type = x
        else type = ''
        setShowFieldLive(type)
    }

    const btn_channels_player = (elem, index) => {
        if (router.query.id != elem.id) router.push(`/player?type=live&id=${elem.id}`)
    }

    const stop_propogation_live = (e) => {
        e.stopPropagation()
        let type = 'categories'
        setShowFieldLive(type)
    }
    return (
        <>

            {
                showFieldLive === "program_guide" ?
                    <ProgramGuide
                        callBackArchiveEpg={callBackArchiveEpg}
                        epg={epg.Now ? epg.Now : null}
                        btn_show_info={btn_show_info}
                        channel={activeMedia}
                        btn_fields_live={btn_fields_live}
                        popUpType={showFieldLive}
                        channelList={channels[1].array}
                    /> :
                    showFieldLive === "categories" ?

                        <Categories btn_fields_live={btn_fields_live} stop_propogation_live={stop_propogation_live} favourites={channels[0]} /> : null
            }
            <div id="top_live_player">
                <div className="container_player top_live_player ">
                    <div className="image_back_live_player">
                        <img src={icon_back} alt="" className="btn_back_live" onClick={() => router.history.goBack()} />
                    </div>
                    <div className="top_btns_live_player">
                        <div className="top_btn_live categories" onClick={() => btn_fields_live('categories')}>
                            <span>Categories</span></div>
                        <div className={"top_btn_live fav " + (channelFavourite ? 'isFav' : '')} onClick={() => btn_add_remove_favourites(activeMedia)}>
                            <span>{channelFavourite ? 'Remove from Favourites' : 'Add to Favourites'}</span></div>
                        <div className="top_btn_live epg" onClick={() => btn_fields_live('program_guide')}><span>Program Guide</span>
                        </div>
                        <div className="top_btn_live info" onClick={btn_show_info}><span>Info</span></div>
                    </div>

                    <div className="channel_img_parent">
                        <p>{activeMedia.name}</p>
                        <div className="channel_image_live_player">
                            <img src={activeMedia.image} alt="" />
                        </div>
                    </div>
                </div>
            </div>

            {!showErrorMessage && <div className={"movie_player_middle_controls " + (!activeMedia.has_archive ? 'small' : '')}>
                <div className="btns_mid_controls btn_prev_player" onClick={btn_previous_channel} onDoubleClick={e => e.stopPropagation()}>
                    <div className={'icon_control_player'}></div>
                </div>
                {activeMedia.has_archive &&
                    <div className="btns_mid_controls btn_back_forward live" onClick={show_time_shift} onDoubleClick={e => e.stopPropagation()}>
                        <div className={'icon_control_player'}></div>
                    </div>
                }
                <div className="btns_mid_controls btn_play" onClick={btn_play_pause} onDoubleClick={e => e.stopPropagation()}>
                    <div
                        className={`${playPause ? 'icon_control_player_play' : 'icon_control_player_pause'} icon_control_player`}></div>
                </div>
                {activeMedia.has_archive &&
                    <div className="btns_mid_controls btn_forward live hide_hover">
                        <div className={'icon_control_player hide_hover'}></div>
                    </div>
                }
                <div className="btns_mid_controls btn_next_player" onClick={btn_next_channel} onDoubleClick={e => e.stopPropagation()}> 
                    <div className={'icon_control_player'}></div>
                </div>
            </div>}


            <div className="bottom_live_container bottom_live_player">
                <div className="full_screen_btn btn_full_live_stream" onClick={btn_full_screen} onDoubleClick={e => e.stopPropagation()}>
                    <img src={fullScreen ? icon_small_screen : icon_full_screen} alt="" />
                </div>
                {info ?
                    <InfoField
                        epg={epg.Now ? epg.Now : null}
                        channel={activeMedia}
                        btn_show_info={btn_show_info}
                    />
                    : null}

                <div className="info_channels_buttons">
                    <div className="inf_epg_live">
                        <div className="now_epg">
                            <div className="icon_epg"><span>Now</span></div>
                            <span
                                className="text_epg"><span>{epg && epg.Now ? formatDate(new Date(Number(epg.Now.start_ut * 1000)), 'HH:mm') : null}</span> {epg.Now && epg.Now.title ? epg.Now.title : null}  </span>
                        </div>
                        <div className="now_epg">
                            <div className="icon_epg"><span>Next</span></div>
                            <span
                                className="text_epg"><span>{epg.next ? formatDate(new Date(epg.next.start_ut * 1000), 'HH:mm') : null}</span> {epg.next && epg.next.title ? epg.next.title : null}</span>
                        </div>
                    </div>
                    <div className="btns_live_bottom">
                        {activeList.map(e => {
                            return (
                                (isGuest || !channels[0].array.length) && e.id === 0 ? null :
                                    <div key={e.id} style={{ backgroundColor: e.active ? '#38334D' : '#13111A' }}
                                        onClick={() => btnSortChannel(e)} className="btn_live_bottom">
                                        <span>{e.name}</span>
                                    </div>
                            )
                        })}
                    </div>
                </div>

                <div className="channel_list_live">
                    <Slider {...settings}>
                        {channels[activeListIndex].array.map((e, i) => {
                            return (
                                <div key={e.id} className="card_channel_live" onClick={() => btn_channels_player(e, i)}>
                                    <img src={e.image} className='img_card_live' alt="" onError={(targ) => targ.target.src = localStorage.getItem('logo')} />

                                    {e.is_protected ?
                                        <img className={'icon_lock_card'} src={icon_lock} alt="" />
                                        : null}
                                    {e.archived_channel ?
                                        <img className={'icon_rec_card'} src={icon_rec} alt="" />
                                        : null}
                                    {!e.canWatch ?
                                        <img className={'icon_premium_card'} src={icon_premium} alt="" />
                                        : null}
                                </div>
                            )
                        })}
                    </Slider>

                </div>

            </div>
        </>
    )
}